<template>
  <div class="wrapper">
    <!-- <div class="filter white_box">
      <p class="font_14_black">当前客户：</p>
      <el-select
        class="custom-os"
        v-model="selectedValue"
        @change="selectChange"
        filterable
        default-first-option
        size="medium"
        placeholder="请选择客户或输入关键字搜索"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <button-a color="#f26828" class="query" @click.native="query()">查询</button-a>
      <button-a color="#08a752" @click.native="reset()">重置</button-a>
    </div> -->
    <div class="white_box">
      <title-a padding="48" title="企业信息" />
      <div class="title_border" />
      <div class="compony h_padding48">
        <div class="row">
          <div class="user_pic">
            <div class="pic">
              <img :src="customerPic" alt />
            </div>
            <div class="modify_pic pointer" @click="edit_pic()">
              <img src="@/assets/icons/edit@2x.png" alt />
            </div>
          </div>
          <div class="compony-info">
            <div class="row top">
              <p class="compony-name font_16_black">{{customerName}}</p>
              <tag
                v-show="status === 1"
                class="tag"
                color="#08a752"
                bgcolor="#e1ffe8"
                bdcolor="#fff"
                name="服务中"
              />
            </div>
            <div class="row service-row">
              <span class="font_14_gray">产品服务</span>
              <tag
                v-for="(list, key) in contractList"
                :key="key"
                class="service-tag"
                :name="contractType(list[0].contractType).replace('协议','')"
                color="#fff"
                bgcolor="#f26828"
                bdcolor="#f26828"
              />
              <!-- <tag v-show="hasService('外包协议')" class="tag" name="岗位外包" />
              <tag v-show="hasService('派遣协议')" class="tag" name="员工派遣" />
              <tag v-show="hasService('劳务协议')" class="tag" name="劳务外包" />
              <tag v-show="hasService('社保协议')" class="tag" name="社保代理" />
              <tag v-show="hasService('薪酬协议')" class="tag" name="薪酬代发" />-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="white_box contract-box">
      <title-a padding="48" title="协议信息" />
      <div class="title_border" />
      <div class="contract">
        <el-tabs v-show="contractData.length > 0" v-model="activeTab" @tab-click="handleClick">
          <el-tab-pane
            v-for="(list, key) in contractList"
            :key="key + ''"
            :label="contractType(list[0].contractType)"
            :name="key + ''"
          >
            <div class="block">
              <el-carousel trigger="click" height="450px" indicator-position="none">
                <el-carousel-item v-for="(item, key) in list" :key="key">
                  <div class="row">
                    <div class="contract">
                      <div class="key-value">
                        <div class="item">
                          <div class="font_14_gray left">协议名称</div>
                          <div class="font_14_black right">{{item.contractName}}</div>
                        </div>
                        <div class="item">
                          <div class="font_14_gray left">协议甲方</div>
                          <div class="font_14_black right">{{item.customerId}}</div>
                        </div>
                        <div class="item">
                          <div class="font_14_gray left">协议乙方</div>
                          <div class="font_14_black right">{{item.invoiceUnitId}}</div>
                        </div>
                        <div class="item">
                          <div class="font_14_gray left">协议类型</div>
                          <div class="font_14_black rihgt">{{contractType(item.contractType)}}</div>
                        </div>
                        <div class="item">
                          <div class="font_14_gray left">签订时间</div>
                          <div class="font_14_black right">{{date(item.signTime)}}</div>
                        </div>
                        <div class="item">
                          <div class="font_14_gray left">协议开始时间</div>
                          <div class="font_14_black right">{{date(item.beginTime)}}</div>
                        </div>
                        <div class="item">
                          <div class="font_14_gray left">协议结束时间</div>
                          <div class="font_14_black right">{{date(item.endTime)}}</div>
                        </div>
                        <div class="item" v-show="item.isAttachments">
                          <div class="font_14_gray left">附件</div>
                          <div
                            class="font_14_black right pdf"
                            @click="downloadPdf(item.contractId)"
                          >
                            <el-button type="primary" size="mini" icon="el-icon-download" circle></el-button>
                          </div>
                        </div>
                      </div>
                      <div class="key-value">
                        <div class="item">
                          <div class="font_14_gray left">结算日</div>
                          <div class="font_14_black right">{{'每月 ' + item.settlementDate + ' 日'}}</div>
                        </div>
                        <div class="item">
                          <div class="font_14_gray left">费用支付日</div>
                          <div class="font_14_black right">{{'每月 ' + item.paymentDate + ' 日'}}</div>
                        </div>
                        <div class="item">
                          <div class="font_14_gray left">发薪日</div>
                          <div class="font_14_black right">{{'每月 ' + item.salaryDate + ' 日'}}</div>
                        </div>
                        <div class="item" style="margin-bottom: 12px;">
                          <div class="font_14_gray left">乙方风险</div>
                          <div class="font_14_black right risk" v-if="item.assumeRisk">
                            <tag
                              v-for="(item, key) in item.assumeRisk.split(',')"
                              :key="key"
                              class="tag"
                              :name="item"
                              color="#000"
                              bgcolor="#fff"
                              bdcolor="#b8bac9"
                            />
                          </div>
                        </div>
                        <div class="item" style="min-width: 600px;"> 
                          <el-table
                            :data="item.contractJob"
                            size="mini"
                            max-height="300"
                            stripe
                            tooltip-effect="dark"
                            :header-row-style="{height: '30px', fongSize: '14px', color: '#000', backgroundColor: '#fafbff'}"
                            :header-cell-style="{backgroundColor: 'transparent'}"
                            :row-style="{height: '30px', backgroundColor: '#fff'}"
                            style="width: 100%;min-width: 500px;font-size: 14px;color: #707070;border: 1px solid #e5e5e5;border-radius: 6px"
                          >
                            <!-- 占位列 -->
                            <el-table-column :width="35 | translateWidth"></el-table-column>
                            <!-- 多选框 -->
                            <!-- <el-table-column type="selection" width="66"></el-table-column> -->
                            <!-- <el-table-column type="index" width="94"></el-table-column> -->
                            <el-table-column prop="jobName" label="服务项目" min-width="200" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="cost" label="服务费" min-width="120" show-overflow-tooltip></el-table-column>
                            <el-table-column label="是否含税" min-width="100">
                              <template slot-scope="scope">{{scope.row.isContainsTax?"是":"否"}}</template>
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-tab-pane>
          <el-tab-pane disabled name="disabled"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 修改头像 -->
    <el-dialog title :visible.sync="edit_pic_mask" width="24%" center>
      <h3 class="export-title font_16_black">修改头像</h3>
      <el-upload
        ref="upload"
        class="upload"
        show-file-list
        :file-list="fileList"
        :limit="1"
        :auto-upload="false"
        :before-upload="beforeUpload"
        :action="upload_url"
        :headers="headers"
        :on-success="upload_ok"
        accept=".jpg, .jpeg, .png"
      >
        <div class="upload">
          <el-button size="small" type="primary">选择图片</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，小于1M</div>
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <div class="save_btn">
          <button-a
            :disabled="button_disabled"
            padding="0.52vw 6.6vw"
            color="#fff"
            bgcolor="#f26828"
            @click.native="savePic()"
          >保存</button-a>
        </div>
      </span>
    </el-dialog>
    <!-- 操作成功 -->
    <el-dialog title :visible.sync="success_mask" width="18%" center>
      <div class="success_icon">
        <img src="@/assets/icons/check002-E007@2x.png" alt />
      </div>
      <h3 class="export-title font_16_black" style="margin-bottom: 0;">修改成功</h3>
      <span slot="footer" class="dialog-footer">
        <div class="save_btn">
          <button-a
            padding="10px 54px"
            color="#fff"
            bgcolor="#f26828"
            @click.native="success_mask = false"
          >确定</button-a>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Get, Download } from "@/js/http.js";
import { getToken, dateConvert, limitUpload } from "@/js/tool.js";
import { Message } from "element-ui";

export default {
  components: {},
  props: {},
  data() {
    return {
      edit_pic_mask: false, // 修改头像遮罩
      success_mask: false, // 操作成功遮罩
      button_disabled: false,
      // 搜索与筛选
      options: [
        // 组织搜索框
      ],
      selectedValue: "", // 客户id
      activeTab: "0",

      contractData: [], // 协议列表
      customerShortName: "", // 客户简称

      customerPic: "",
      headers: {
        Authorization: "Bearer " + getToken(),
        "X-Fanyun-api-version": process.env.VUE_APP_VERSION
      },
      fileList: [],
      customerName: "",
      status: 0
    };
  },
  watch: {},
  computed: {
    // customerPic() {
    //   return this.$store.state.user_pic;
    // },
    // 上传头像地址
    upload_url() {
      return (
        process.env.VUE_APP_APIROOT +
        "/api/v1/customers/logo"
      ); // 头像上传url
    },
    // 用于渲染的协议数组
    contractList() {
      let array = ["外包", "劳务派遣", "人事外包", "薪酬外包"];
      let outputList = [];
      array.map(value => {
        let list = this.contractData.filter(
          item => item.contractType === value
        ); // 岗位外包协议数组
        if (list.length > 0) outputList.push(list);
      });
      return outputList;
    }
  },
  methods: {
    // 获取客户列表
    getOptions() {
      Get("api/v1/customers/selectors").then(res => {
        this.options = res.data;
        this.selectedValue = this.$route.params.customerId || res.data[0].value; // 如果有传入customerId则初始化为选择该id
        this.query();
      });
    },
    // 查询
    query() {
      this.customerPic = "";
      // 协议
      Get("api/v1/customers/contracts", {
        // customerId: this.selectedValue
      }).then(res => {
        this.contractData = res.data;
        this.activeTab = "0"; // el-tabs的name不接受数字
      });
      // 头像
      Get(
        "api/v1/customers/logo",
        {
          // 不再需要 arraybuffer，因为接口现在返回 base64 字符串
        },
        {
          customerId: this.selectedValue
        }
      )
        .then(res => {
          console.log('获取logo响应:', res)
          if (res.isSuccess && res.data) {
            // 接口返回的 data 已经是 base64 字符串
            const imageData = `data:${res.msg};base64,${res.data}`
            this.customerPic = imageData
            // 只更新本地变量，不更新 Vuex store，避免覆盖导航栏的用户头像
          } else {
            // 没有头像，使用默认图片
            const defaultImage = require('@/assets/header.png')
            this.customerPic = defaultImage
            // 只更新本地变量，不更新 Vuex store，避免覆盖导航栏的用户头像
          }
        })
        .catch(err => {
          console.error('获取logo失败:', err)
          // 出错时使用默认图片，不显示错误提示
          const defaultImage = require('@/assets/header.png')
          this.customerPic = defaultImage
          // 只更新本地变量，不更新 Vuex store，避免覆盖导航栏的用户头像
        });
      // 名称状态
      Get("api/v1/customers/info", {
        // customerId: this.selectedValue
      }).then(res => {
        this.customerName = res.data.customerName;
        this.customerShortName = res.data.customerShortName || res.data.customerName;
        this.status = res.data.status;
        // 存储到localStorage
        localStorage.setItem('companyName', res.data.customerName);
        // 从localStorage恢复专属客服数据
        const user_name = localStorage.getItem('user_name');
        const server_name = localStorage.getItem('server_name');
        const server_phone = localStorage.getItem('server_phone');
        const server_mobilephone = localStorage.getItem('server_mobilephone');
        const server_email = localStorage.getItem('server_email');
        const tenant_id = localStorage.getItem('tenant_id');
        const tenant_name = localStorage.getItem('tenant_name');
        // 存储到Vuex store
        this.$store.commit('login', {
          user_name: user_name,
          server_name: server_name,
          server_phone: server_phone,
          server_mobilephone: server_mobilephone,
          server_email: server_email,
          tenant_id: tenant_id,
          tenant_name: tenant_name || res.data.customerName
        });
      });
    },
    // 重置按钮
    reset() {
      this.selectedValue = this.options[0].value;
    },
    // 判断协议类型
    contractType(name) {
      if (!name) return "";
      // 支持两种格式："外包" 或 "外包协议"
      switch (name.replace('协议', '')) {
        case "派遣":
          return "劳务派遣";
        case "社保":
          return "人事外包";
        case "薪酬":
          return "薪酬外包";
        case "外包":
          return "外包";
        case "劳务":
          return "外包";
        default:
          return name;
      }
    },
    // 判断产品服务
    hasService(name) {
      return this.contractData.find(item => {
        return item.contractType === name;
      });
    },
    // 日期
    date(date) {
      return dateConvert(date);
    },
    // 获取附件文件名（格式：客户简称_协议类型_年月日）
    getAttachmentFileName(contractType) {
      // 获取当前日期，格式：YYYYMMDD
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const dateStr = year + month + day;
      
      // 获取客户简称
      const customerShortName = this.customerShortName || '未知客户';
      
      // 获取协议类型全称
      const contractTypeName = this.contractType(contractType) || contractType || '协议附件';
      
      // 构建文件名：客户简称_协议类型_年月日.zip
      return `${customerShortName}_${contractTypeName}_${dateStr}.zip`;
    },
    // 下载附件
    downloadPdf(contractId) {
      Download(
        `api/v1/customers/attachments/${contractId}`,
        {
          version: 'v1'
        }
      );
    },
    // 点击上传头像按钮
    edit_pic() {
      this.edit_pic_mask = true;
    },
    // 确定新头像
    savePic() {
      this.$refs.upload.submit();
    },
    beforeUpload(file) {
      let isOk = limitUpload(file, 1);
      if (!isOk) {
        Message.error({
          customClass: "top-layer",
          message: "文件大小超过1M"
        });
      }
      return isOk;
    },
    // 上传头像成功
    upload_ok(res) {
      if (res.isSuccess) {
        this.edit_pic_mask = false;
        this.success_mask = true;
        // 重新获取头像
        this.query();
        // 直接更新store，确保顶部logo更新
        setTimeout(() => {
          this.$store.commit('user_pic', this.customerPic);
        }, 500);
      } else {
        Message.error({
          customClass: "top-layer",
          message: res.msg
        });
      }
      this.$refs.upload.clearFiles(); // 清空文件列表
    },
    handleClick() {},
    selectChange() {}
  },
  created() {},
  mounted() {
    this.getOptions();
  }
};
</script>
<style lang="scss" scoped>
// 布局样式
.contract{
  // overflow: scroll;
}
.wrapper{
  // overflow: scroll;
}
.wrapper {
  padding: 32px 32px 24px;
  > div {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .filter {
    display: flex;
    align-items: center;
    padding: 22px 48px;
  }
  .compony {
    padding: 48px 0 94px 144px;
    .compony-info {
      .top {
        margin-bottom: 25px;
      }
      .compony-name {
        margin-right: 25px;
      }
    }
  }
  .contract-box {
    padding-bottom: 70px;
  }
  .contract {
    background-color: #fff;
  }
}
// 小标签
.tag {
  margin-left: 16px;
}
// 产品服务行
.service-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
// 产品服务标签
.service-tag {
  margin-left: 0;
  margin-right: 8px;
      color: orange !important;
    background-color: #fff8f0 !important;
    border: 1px solid !important;
}
// 选项卡
.el-tabs {
  ::v-deep .el-tabs__nav .el-tabs__item {
    padding: 0 49px;
    height: 64px;
    font-size: 16px;
    line-height: 64px;
    &.is-active {
      color: #f26828;
    }
    &:hover {
      color: #f26828;
    }
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #f26828;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    background-color: #fff;
  }
}
// 轮播
.block {
  width: 1180px;
  .row {
    justify-content: center;
    background-color: #fff;
  }
  .contract {
    display: flex;
    min-width: 1020px;
    width: 100%;
    min-height: 450px;
    padding: 40px 35px;
    background-color: #fafbff;
    border-radius: 8px;
  }
  .tag {
    margin-left: 0;
    margin-right: 10px;
  }
  .pdf {
    display: flex;
    width: 168px;
    cursor: pointer;
  }
  .pdf_icon {
    margin-right: 15px;
  }
}
// 键值对
.key-value {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: stretch;
  margin-right: 50px;
  &:last-child {
    margin-right: 0;
  }
  .item {
    display: flex;
    margin-bottom: 24px;
  }
  .left {
    width: 104px;
    margin-right: 50px;
    text-align: right;
  }
  .right {
    width: 300px;
  }
  .key {
    margin-right: 50px;
    p {
      text-align: right;
    }
  }
  p {
    margin-bottom: 32px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
.save_btn {
  padding-top: 30px;
}
.risk {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.font_14_black{
  width:250px !important;
  white-space: normal !important;
  word-wrap: break-word;
  word-break: break-all;
}
.font_14_black.right {
  width: 300px;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}
</style>